import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=8a13eefa&scoped=true"
var script = {}
import style0 from "./Press.vue?vue&type=style&index=0&id=8a13eefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a13eefa",
  null
  
)

export default component.exports